export enum VariantType {
  Disabled = 'disabled'
}
